import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { IStandardsSetContentRelationResponse } from "../../types/IStandardsSetContentRelationResponse";

interface StandardsSetRelationsQueryProps {
  standardSetId: string;
  options?: Omit<
    Parameters<typeof useQuery<IStandardsSetContentRelationResponse[]>>,
    "queryKey" | "queryFn"
  >;
}

export const useFetchStandardsSetRelations = ({
  standardSetId,
  options,
}: StandardsSetRelationsQueryProps) => {
  return useQuery<IStandardsSetContentRelationResponse[], Error>({
    ...options,
    queryKey: [ApiCatalog.draftContent.key, standardSetId, "relation"],
    queryFn: () =>
      api().get<IStandardsSetContentRelationResponse[]>(
        `${ApiCatalog.draftContent.endpoint}${standardSetId}/content-relation/`,
      ),
    enabled: standardSetId !== "",
  });
};
